export default {
  deliveryOptionLabel: {
    id: 'express_replacement_shipping_delivery_option_label',
    defaultMessage: 'Get it by {min} - {max} • Free',
  },
}
